import React from "react";
import { General, GovernyInfo, Spell } from "../../../../lib/types";
import HelpIcon from "../../../Common/HelpIcon";
import SpellCell from "./SpellCell";
import AlertIcon from "../../../Common/AlertIcon";
import { isSpellCast } from "../../../../lib/commonFunctions";
import GovernoratePivotColumn from "../../../Common/GovernoratePivotColumn";

interface IProps {
  govId?: number;
  mageGeneral: General;
  availableSpells: Spell[];
  castSpells: {
    id: number;
    tableId: number;
    level: number;
    targetId: number;
  }[];
  spellCastLimit: number,
  positive: boolean;
  closed: boolean;
  members: GovernyInfo[];
}

const SpellPlannerGrid = ({
  govId,
  availableSpells,
  castSpells,
  spellCastLimit,
  positive,
  closed,
  members
}: IProps) => (
<div className="box scrollable" style={{ paddingBottom: "24px" }}>
  {
    !availableSpells || !availableSpells.length
      ? <div className="text-info">
        <p>No {positive ? "buffs" : "debuffs or damage spells"} available</p>
      </div>
      : <>
        <table className={`table spells ${closed ? "spells-using" : ""}`} style={{ width: "auto" }}>
          <thead>
          <tr>
            <th className={"text-left"} style={{ width: "125px" }}>Target</th>
            {
              availableSpells.map(spell => <th style={{ width: "100px" }}>
                <div style={{ height: "40px", paddingTop: "5px" }}>{spell.name}</div>
                <div style={{ paddingTop: "5px" }}>
                  <HelpIcon
                    title={spell.name}
                    content={spell.description}
                    iconClasses={["white", "align-sub"]}
                  />
                </div>
                {spell.blocked && <>&nbsp;<AlertIcon
                  classes={["align-sub"]}
                  title={spell.generalSpell
                    ? (isSpellCast(castSpells, spell.id) ? "Cooldown" : "Already planned")
                    : "Magic Palace"}
                  content={spell.generalSpell
                    ? (isSpellCast(castSpells, spell.id)
                      ? `${spell.name} can be cast only once in two counts.`
                      : "General spell needs to cool down for one count when it was cast last count.")
                    : "Magic Palace has to be built and not damaged to cast Dragon's breath."}
                /></>}
              </th>)
            }
          </tr>
          </thead>
          <tbody>
          {members.map(governorate => <tr>
            <GovernoratePivotColumn
              id={governorate.id}
              name={governorate.name}
              race={governorate.race.name}
              commander={governorate.commander}
              emperor={governorate.emperor}
            />
            {
              availableSpells.map(spell => <SpellCell
                govId={govId}
                spell={spell}
                target={governorate}
                cast={castSpells
                  .find(cast => cast.targetId === governorate.id && cast.id === spell.id)}
                disabled={!(castSpells.length < spellCastLimit)
                || spell.blocked}
              />)
            }
          </tr>)
          }
          </tbody>
        </table>
      </>
  }
</div>
)

export default SpellPlannerGrid;
